import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import FieldList from '../CollaborativeIndexations/FieldList'

class Summary extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
    }

    render()
    {
        const { t,fields } = this.props

        return (
            <div>
                {t('visualizer:toolbar.left.collaborativeIndexationCreation.form.common.steps.summary.title')}

                <FieldList fields={fields} />
            </div>
        )
    }
}

export default withTranslation()(Summary)
